import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { InformationPopupComponent } from '../information-popup/information-popup.component';

const routes: Routes = [
  {
    path: '',
    component: InformationPopupComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [InformationPopupComponent],
  exports: [InformationPopupComponent]
})
export class InformationPopupComponentModule {}
